<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
      <h4>重置职业培训学期</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="130px"
      >
        <el-form-item
          label="职业培训业务"
          prop="categoryId"
        >
          <el-select
            size="small"
            v-model="form.categoryId"
            placeholder="请选择业务"
          >
            <el-option
              v-for="item in trainingCategoryList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          :span="20"
          :xs="16"
          class="footer-left"
        >
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
          :xs="8"
        >
          <el-button
            :loading="isSaving"
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
          >确认</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getTrainingCategories } from "../service/globalPriceSetting.service";
import { resetTrainingTerm } from "../service/common.service";
export default {
  data() {
    return {
      isSaving: false,
      showError: false,
      errorMessage: "",
      submitBtnClass: "primary",
      submitBtnDisable: false,
      trainingCategoryList: [],
      form: {
        categoryId: ""
      },
      rules: {
        categoryId: [
          {
            required: true,
            message: "业务是必须的",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    getTrainingCategories(3).then(result => {
      if (!!result && result.success) {
        this.trainingCategoryList = result.data;
      }
    });
  },
  watch: {},
  methods: {
    checkAllInputs() {
      let isValid = true;
      this.$refs.form.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      return isValid;
    },
    close() {
      this.$refs["form"].resetFields();
      this.$emit("closeDialog");
    },
    save() {
      if (!this.checkAllInputs()) return;
      this.$confirm(
        "您确定要重置当前学期吗？重置后，当前学期数据都会归档不可用。",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.submitBtnDisable = true;
          this.isSaving = true;
          let result = resetTrainingTerm(this.form.categoryId)
            .then(result => {
              if (!result.success) {
                this.errorMessage = result.message;
                this.showError = true;
              } else {
                this.$message("学期重置成功");
                this.showError = false;
                this.$emit("saveSuccess");
                this.close();
              }
              this.submitBtnDisable = false;
              this.isSaving = false;
            })
            .catch(() => {
              this.submitBtnDisable = false;
              this.isSaving = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/resetTrainingTerm.vue